module.exports = __webpack_public_path__ + "static/media/RCMP-logo.29c602c1.png";